export function formatPlanData(data, labels = [], result = {}) {
    const capitalize = src => src.charAt(0).toUpperCase() + src.slice(1)
    const formatLabel = label => {
        let temp = label.split('_')

        // check words count and capitalize first and last words
        if (temp.length < 1) temp.splice(0, 1, capitalize(temp[0]))
        else if (temp[0].indexOf('xxx') !== -1) {
            temp.splice(0, 1, temp[0].toUpperCase())
            temp.splice(temp.length - 1, 1, capitalize(temp[temp.length - 1]))
        } else {
            temp.splice(0, 1, capitalize(temp[0]))
            temp.splice(temp.length - 1, 1, capitalize(temp[temp.length - 1]))
        }

        return temp.join(' ')
    }
    // iterate each key in response object. it will be charts
    Object.keys(data).forEach(chart => {

        /*
         iterate each key in charts. it will be labels and count
        */
        Object.keys(data[chart]).forEach(item => {
            labels.push({ label: formatLabel(item), count: data[chart][item] })
        })

        // assign iterated data in result obj
        Object.assign(result, { [chart]: labels })
        labels = [] // clean labels array before iterate next chart
    })

    return result
}
